import Typography from '@mui/material/Typography';
import React, { FC } from 'react';

import type { HeaderDetailsProps, SidebarLink } from '../types/props';

import { HeaderContainer } from './HeaderContainer';

const headerRoutes: Record<string, string> = {
	'/profile': 'Profile',
	'subscriptions/leasing-rights': 'Leasing Rights',
	'lease-detail': 'Lease Detail',
	'invoice-detail': 'Invoice Detail',
	'subscriptions/tax-exempt': 'Tax Exempt Certificates',
	'subscriptions/contract-docs': 'Contract Docs',
	'contract-docs': 'Contract Docs',
	'subscription-detail': 'Subscription Detail',
	lease: 'Create Lease',
};

function getPageTitle(title: string, links: any[], pathname: string): string | null {
	const findRoute = links.find(({ path }) => path === pathname || path === `/${pathname}`)?.name;
	if (findRoute) return findRoute;
	if (headerRoutes[pathname]) {
		if (title === headerRoutes[pathname]) {
			return null;
		}
		return headerRoutes[pathname];
	}
	const splitRoute = pathname.split('/')[0] as string;
	if (headerRoutes[splitRoute]) {
		if (title === headerRoutes[splitRoute]) {
			return null;
		}
		return headerRoutes[splitRoute];
	}
	return null;
}

type HeaderProps = {
	title: string;
	navLinks: SidebarLink[];
	HeaderDetails: any;
	headerDetails?: HeaderDetailsProps | null;
	pathname: string;
};

export const Header: FC<HeaderProps> = ({ title, navLinks, headerDetails, HeaderDetails, pathname }) => (
	<HeaderContainer id='pca__detail_header'>
		<div id='pca__header-center--title' data-cy='heading-text'>
			<Typography variant='h4' style={{ fontSize: '25px', fontWeight: 600, textTransform: 'capitalize' }}>
				{title || ''} {getPageTitle(title, navLinks, pathname)}
			</Typography>
		</div>
		<HeaderDetails headerDetails={headerDetails} />
	</HeaderContainer>
);
